const colorPalette = ['#8A1415', '#A2A3A4', '#E1242B', '#F88C86'];

export default {
    colorPalette,
    color: colorPalette,
    map: {
        locationLabelColor: '#333333',
        locationBorderColor: 'white',
        locationInRangeColorSpectrum: [
            '#4D002D',
            '#87122D',
            '#BD1416',
            '#EF2F31',
            '#F781BF',
            '#D03F8F',
            '#984EA3',
            '#5D8591',
            '#41B6C4',
            '#CCECE6',
        ],
        locationOutOfRangeColor: '#ECEDED',
        sliderAxisColor: '#F3F5F4',
        sliderPointColor: '#E2E5E4',
        sliderPlayButtonColor: '#C1C8CB',
        sliderPlayButtonBorderColor: '#C1C8CB',
        sliderPlayButtonHoverColor: '#1FBA59',
        sliderPlayButtonBorderHoverColor: '#1FBA59',
        roam: 'move',
    },
};
